import { jsxs as k } from "react/jsx-runtime";
import { c as C } from "../../index-LULxUVKG.js";
import { Children as E, useId as I, useState as b, createRef as L, useRef as N, useEffect as d, cloneElement as p } from "react";
import { s as l } from "../../Tabs.module-5GGKgLcA.js";
const D = ({
  children: h,
  className: y,
  fullWidth: R = !1,
  defaultSelected: w = 0,
  inline: f,
  onSelected: a,
  ...A
}) => {
  const [v, ...e] = E.toArray(h), T = I(), [s, o] = b(w), [c, i] = b(), m = e.map((t, r) => `${T}-tab-${r}`), n = e.map(() => L()), u = N(!1), g = (t) => {
    t.key === "ArrowLeft" && s > 0 && (o(s - 1), i(s - 1)), t.key === "ArrowRight" && s < e.length - 1 && (o(s + 1), i(s + 1));
  };
  return d(() => {
    var t, r;
    c !== void 0 && ((r = (t = n[c]) == null ? void 0 : t.current) == null || r.focus());
  }, [c]), d(() => {
    u.current ? a == null || a(s) : u.current = !0;
  }, [a, s]), /* @__PURE__ */ k(
    "div",
    {
      className: C(
        l.tabsCard,
        { [l.withBorder]: f },
        y
      ),
      ...A,
      children: [
        p(v, {
          setActiveTab: o,
          fullWidth: R,
          activeTab: s,
          onKeyDown: g,
          tabRefs: n,
          tabIds: m,
          inline: f
        }),
        e.map(
          (t, r) => p(t, {
            hidden: s !== r,
            "aria-describedby": m[r]
          })
        )
      ]
    }
  );
};
export {
  D as Tabs
};
